import { useState, useEffect, useContext } from 'react';
import api from './api/axiosInstance.js';
import { UserContext } from './UserContext.js';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Sidebar from './Sidebar.js';
import { Table, Form, Row, Col, Card, Badge, Image } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Pagination from 'react-bootstrap/Pagination';
import Breadcrumb from './Breadcrumb.js';
import { isAdminType} from './utils/roleUtils.js';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa';
import icNoUsers from './assets/img/ic-empty-box.svg';
import icDelete from './assets/img/ic-delete.svg';
import icEdit from './assets/img/ic-edit.svg';
import icRepeat from './assets/img/ic-repeat.svg';
import UserFilter from './UserFilter.js';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import 'bootstrap-icons/font/bootstrap-icons.css';
import defaultProfileImage from './assets/img/ic-img.svg';
import { resolveMediaUrl } from './utils/mediaUrl';

const UserList = () => {
    
    const [users, setUsers] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const { user } = useContext(UserContext);
    const [currentPage, setCurrentPage] = useState(1);
    const [usersPerPage, setUsersPerPage] = useState(10);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedCity, setSelectedCity] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const indexOfLastUser = currentPage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedRole, setSelectedRole] = useState('');
    const [selectedCompany, setSelectedCompany] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    const [tickets, setTickets] = useState([]);
        useEffect(() => {
            const fetchTickets = async () => {
                try {
                    const res = await api.get(`/api/tickets`);
                    setTickets(res.data);
                } catch (error) {
                    console.error('Error fetching tickets:', error);
                }   
            };
            fetchTickets();
        }, []);

    useEffect(() => {
        if (user && isAdminType(user.role)) {
            fetchUsers();
        }
    }, [user]);

    const fetchUsers = async () => {
        try {           
            const res = await api.get(`/api/users`);
            console.log('USERS LIST RESPONSE:', res.data);
            setUsers(res.data);
            setFilteredUsers(res.data); // Initialize with full list
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {
        const lowercasedQuery = String(searchQuery || '').toLowerCase().trim();

        let filteredResults = users.filter((u) => {
            // ✅ if search is empty, keep everyone (including users with no names yet)
            if (!lowercasedQuery) return true;

            const first = String(u.firstName || '').toLowerCase();
            const last = String(u.familyName || '').toLowerCase();
            const email = String(u.email || '').toLowerCase();

            return (
                first.includes(lowercasedQuery) ||
                last.includes(lowercasedQuery) ||
                email.includes(lowercasedQuery)
            );
        });

        if (selectedCountry) {
            filteredResults = filteredResults.filter(u => u.country === selectedCountry);
        }

        if (selectedCity) {
            filteredResults = filteredResults.filter(u => u.city === selectedCity);
        }

        if (selectedRole) {
            filteredResults = filteredResults.filter(u => u.role === selectedRole);
        }

        if (selectedCompany) {
            filteredResults = filteredResults.filter(u => u.company && u.company.title === selectedCompany);
        }

        setFilteredUsers(filteredResults);
        setCurrentPage(1);
    }, [searchQuery, selectedCountry, selectedCity, selectedRole, selectedCompany, users]);


    const handleDeleteUser = (id) => {
        setSelectedUserId(id);
        setShowDeleteModal(true);
    };

    const confirmDeleteUser = async () => {
        try {
            await api.delete(`/api/users/${selectedUserId}`);
            const updated = users.filter(user => user._id !== selectedUserId);
            setUsers(updated);
            setFilteredUsers(updated); // ✅ update the visible list too
            setShowDeleteModal(false);
        } catch (error) {
            console.error('Error deleting user:', error);
        }
    };

    const toggleActivityStatus = async (userId, currentStatus) => {
        try {
            const endpoint = currentStatus ? 'deactivate' : 'activate';
            await api.put(`/api/users/${userId}/${endpoint}`);
            const updatedStatus = !currentStatus;
            const update = (list) => list.map((u) => u._id === userId ? { ...u, activityStatus: updatedStatus } : u);
            setUsers(update);
            setFilteredUsers(update);
        } catch (error) {
            console.error('Error toggling activity status:', error);
        }
    };

    
    const sortUserByName = () => {

    }

    const sortUserByCountry = () => {
        
    }

    const sortUserByCity = () => {
        
    }
    
    const sortUserByType = () => {
        
    }

    const sortUserByOnboarding = () => {
        
    }

    const sortUserByStatus = () => {
        
    }

    const noUsers = filteredUsers.length === 0;

    return (
        <>
            <Sidebar ticketCount={tickets.length} />
            <main className="main-content flex-grow-1">
                <Container>
                    <Row>
                        <Col>
                            <Breadcrumb />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row>
                                        <Col xs={12}>
                                            <h1>Users</h1>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12}>
                                            <UserFilter
                                                searchQuery={searchQuery}
                                                setSearchQuery={setSearchQuery}
                                                selectedCountry={selectedCountry}
                                                setSelectedCountry={setSelectedCountry}
                                                selectedCity={selectedCity}
                                                setSelectedCity={setSelectedCity}
                                                selectedRole={selectedRole}
                                                setSelectedRole={setSelectedRole}
                                                selectedCompany={selectedCompany}
                                                setSelectedCompany={setSelectedCompany}
                                                users={users}
                                            />
                                            {noUsers ? (
                                                <Row>
                                                    <Col md={12}>
                                                        <Row className="mb-3">
                                                            <Col md={6} className="no-result offset-md-3 d-flex flex-column justify-content-center align-items-center text-center">
                                                                <Image src={icNoUsers} alt="No users" className="mb-4" />
                                                                <h2 className="mb-3">No users yet.</h2>
                                                                <p className="mb-4">Your users will be displayed here.</p>
                                                                <Button as={Link} to="/user-add" variant="primary">Add User</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            ) : (
                                                <Row>
                                                    <Col>
                                                        <div className="table-responsive list">
                                                            <Table>
                                                                <thead>
                                                                    <tr>
                                                                        <th className="th-fixed-company" onClick={sortUserByName} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Name
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-company-country" onClick={sortUserByCountry} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Country 
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-city" onClick={sortUserByCity} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                City
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-phone">
                                                                            <div>
                                                                                Phone
                                                                            </div>
                                                                        </th>
                                                                        <th className="th-fixed-users" onClick={sortUserByType} style={{ cursor: 'pointer' }}>
                                                                            User Type
                                                                            <span>
                                                                                <FaCaretUp />
                                                                                <FaCaretDown />
                                                                            </span>
                                                                        </th>
                                                                        {/* <th className="th-fixed-jobs" onClick={sortUserByOnboarding} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Onboarding
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th> */}
                                                                        <th className="th-fixed-status"  onClick={sortUserByStatus} style={{ cursor: 'pointer' }}>
                                                                            <div>
                                                                                Status
                                                                                <span>
                                                                                    <FaCaretUp />
                                                                                    <FaCaretDown />
                                                                                </span>
                                                                            </div>
                                                                        </th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {currentUsers.map((user) => (

                                                                        <tr key={user._id}>
                                                                            {/* <Link 
                                                                                to={`/user-edit/${user._id}`} 
                                                                                style={{ textDecoration: 'none', color: 'inherit', flex: '1' }} 
                                                                            > */}
                                                                                <td>
                                                                                    <div>
                                                                                        <img
                                                                                            src={user.profileImage ? resolveMediaUrl(user.profileImage) : defaultProfileImage}
                                                                                            alt={user.firstName}
                                                                                            className="round"
                                                                                        />
                                                                                        <strong>
                                                                                            {(user.firstName || user.familyName)
                                                                                                ? `${user.firstName || ''} ${user.familyName || ''}`.trim()
                                                                                                : (user.email || 'No name')}
                                                                                        </strong>
                                                                                    </div>
                                                                                </td>
                                                                                <td>{user.country || ''}</td>
                                                                                <td>{user.city || ''}</td>
                                                                                <td>{user.phone}</td>
                                                                                <td>{user.role}</td>
                                                                                {/* <td>    
                                                                                    <strong>
                                                                                        50 % */}
                                                                                        {/* {`${user.onboardingProgress}%`} */}
                                                                                    {/* </strong>
                                                                                </td> */}
                                                                                <td>
                                                                                    <OverlayTrigger
                                                                                        placement="top"
                                                                                        overlay={
                                                                                            <Tooltip id={`tooltip-status-${user._id}`}>
                                                                                                {user.activityStatus === true ? "Active" : "Inactive"}
                                                                                            </Tooltip>
                                                                                        }
                                                                                    >
                                                                                        <Badge bg={user.activityStatus === true ? 'active' : 'inactive'}>
                                                                                            &nbsp;
                                                                                        </Badge>
                                                                                    </OverlayTrigger>
                                                                                </td>
                                                                            {/* </Link> */}
                                                                            <td>
                                                                                <Dropdown
                                                                                    drop="down"
                                                                                    align="end"
                                                                                    onToggle={(isOpen) => {
                                                                                        if (isOpen) {
                                                                                        requestAnimationFrame(() => window.dispatchEvent(new Event("resize"))); // ✅ force Popper update
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <Dropdown.Toggle variant="link" className="text-dark p-0">
                                                                                        <i className="bi bi-three-dots-vertical"></i>
                                                                                    </Dropdown.Toggle>

                                                                                    <Dropdown.Menu
                                                                                        renderOnMount
                                                                                        popperConfig={{ strategy: "fixed" }}
                                                                                        style={{ zIndex: 2000 }}
                                                                                    >
                                                                                        
                                                                                        {/* <Dropdown.Item as={Link} to={`/user-invite/${user._id}`} data-text="Invite to complete profile">
                                                                                            <img src={icUserEdit } alt="Invite to complete profile" />
                                                                                            Invite to complete profile
                                                                                        </Dropdown.Item> */}
                                                                                        <Dropdown.Item as={Link} to={`/user-edit/${user._id}`} data-text="Edit">
                                                                                            <img src={icEdit} alt="Edit" />
                                                                                            Edit
                                                                                        </Dropdown.Item>
                                                                                        <Dropdown.Item onClick={() => toggleActivityStatus(user._id, user.activityStatus)} data-text="Activate/Deactivate Account">
                                                                                            <img src={icRepeat} alt="Activate/Deactivate" />
                                                                                            {user.activityStatus ? 'Deactivate Account' : 'Activate Account'}
                                                                                        </Dropdown.Item>
                                                                                        <Dropdown.Item onClick={() => handleDeleteUser(user._id)} data-text="Delete">
                                                                                            <img src={icDelete} alt="Delete" />
                                                                                            Delete
                                                                                        </Dropdown.Item>
                                                                                    </Dropdown.Menu>
                                                                                </Dropdown>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )}

                                            {/* Pagination Row with Total Count, Items Per Page Selector & "Go to Page" Input */}
                                            <Row className="pagination-wrapper">
                                                <Col className="d-flex align-items-center">
                                                    <span>
                                                        Total {filteredUsers.length} {filteredUsers.length === 1 ? 'user' : 'users'}
                                                    </span>
                                                    <Pagination>
                                                        <Pagination.Prev 
                                                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
                                                            disabled={currentPage === 1}
                                                        >
                                                            <BsChevronLeft />
                                                        </Pagination.Prev>
                                                        {[...Array(totalPages).keys()].map(number => (
                                                            <Pagination.Item 
                                                                key={number + 1} 
                                                                active={number + 1 === currentPage} 
                                                                onClick={() => handlePageChange(number + 1)}
                                                            >
                                                                {number + 1}
                                                            </Pagination.Item>
                                                        ))}
                                                        <Pagination.Next 
                                                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} 
                                                            disabled={currentPage === totalPages}
                                                        >
                                                            <BsChevronRight />
                                                        </Pagination.Next>
                                                    </Pagination>
                                                </Col>
                                                <Col className="pagination-controls">
                                                    <div className="pagination-controls-per-page">
                                                        <Form.Select
                                                            value={usersPerPage}
                                                            onChange={(e) => setUsersPerPage(Number(e.target.value))}
                                                        >
                                                            <option value="10">10 / page</option>
                                                            <option value="20">20 / page</option>
                                                            <option value="40">40 / page</option>
                                                        </Form.Select>
                                                    </div>
                                                    <label className="pagination-controls-goto-label" htmlFor="goto-page">
                                                        Go to
                                                    </label>
                                                    <Form.Control
                                                        className="pagination-controls-goto-input"
                                                        type="number"
                                                        value={currentPage}
                                                        onChange={(e) => {
                                                            const newPage = Number(e.target.value);
                                                            if (newPage >= 1 && newPage <= totalPages) {
                                                                setCurrentPage(newPage); // ✅ Only valid pages
                                                            }
                                                        }}
                                                        onBlur={() => {
                                                            if (currentPage < 1) setCurrentPage(1);
                                                            if (currentPage > totalPages) setCurrentPage(totalPages);
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="buttons-row">
                        <Col>
                            {/* <Button variant="outline-secondary" onClick={() => setShowImportModal(true)}>
                                Import users from excel 
                            </Button>
                            <Button variant="outline-secondary" onClick={() => setShowInviteModal(true)}>
                                Invite a user
                            </Button>
                             */}
                            <Link to="/user-add" className="btn btn-outline-primary">
                                Add new user
                            </Link>
                        </Col>
                    </Row>
                    
                    <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>Are you sure you want to delete this user?</Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-secondary" className="me-3" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
                            <Button variant="danger" onClick={confirmDeleteUser}>Delete</Button>
                        </Modal.Footer>
                    </Modal> 

                    {/* <Modal show={showInviteModal} onHide={() => setShowInviteModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Invite a User</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form>
                                
                                <Form.Group controlId="userName" className="mb-3">
                                    <Form.Label>User Name *</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="userName" 
                                        value={inviteData.userName} 
                                        onChange={handleInviteChange} 
                                        required
                                    />
                                </Form.Group>

                                
                                <Form.Group controlId="vat" className="mb-3">
                                    <Form.Label>VAT *</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="vat" 
                                        value={inviteData.vat} 
                                        onChange={handleInviteChange} 
                                        isInvalid={!!vatError}
                                    />
                                    <Form.Control.Feedback type="invalid">{vatError}</Form.Control.Feedback>
                                </Form.Group>

                                
                                <Form.Group className="mb-3">
                                    <Form.Label>Type *</Form.Label>
                                    <div>
                                        <Form.Check 
                                            inline 
                                            label="Firm" 
                                            type="radio" 
                                            name="type" 
                                            value="firm" 
                                            checked={inviteData.type === 'firm'} 
                                            onChange={handleInviteChange}
                                        />
                                        <Form.Check 
                                            inline 
                                            label="Partner" 
                                            type="radio" 
                                            name="type" 
                                            value="partner" 
                                            checked={inviteData.type === 'partner'} 
                                            onChange={handleInviteChange}
                                        />
                                    </div>
                                </Form.Group>
                                
                                <Form.Group controlId="email" className="mb-3">
                                    <Form.Label>Email *</Form.Label>
                                    <Form.Control 
                                        type="email" 
                                        name="email" 
                                        value={inviteData.email} 
                                        onChange={handleInviteChange} 
                                        isInvalid={!!emailError} // Highlight input field if error
                                    />
                                    <Form.Control.Feedback type="invalid">{emailError}</Form.Control.Feedback>
                                </Form.Group>
                                
                                <Form.Group controlId="firstName" className="mb-3">
                                    <Form.Label>First Name Recipient *</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="firstName" 
                                        value={inviteData.firstName} 
                                        onChange={handleInviteChange} 
                                        required
                                    />
                                </Form.Group>
                                
                                <Form.Group controlId="lastName" className="mb-3">
                                    <Form.Label>Last Name Recipient *</Form.Label>
                                    <Form.Control 
                                        type="text" 
                                        name="lastName" 
                                        value={inviteData.lastName} 
                                        onChange={handleInviteChange} 
                                        required
                                    />
                                </Form.Group>
                                
                                <Form.Group controlId="message" className="mb-3">
                                    <Form.Label>Message</Form.Label>
                                    <Form.Control 
                                        as="textarea" 
                                        name="message" 
                                        value={inviteData.message} 
                                        onChange={handleInviteChange} 
                                        rows={3}
                                    />
                                </Form.Group>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowInviteModal(false)}>Cancel</Button>
                            <Button variant="primary" onClick={handleInviteUser}>Send Invitation</Button>
                        </Modal.Footer>
                    </Modal> */}

                    {/* <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Congratulations</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Congratulations! You have successfully invited a new user to join aBROADIFY.</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={() => setShowSuccessModal(false)}>Go to Users</Button>
                        </Modal.Footer>
                    </Modal> */}

                    {/* Import Users Modal */}
                    {/* <Modal show={showImportModal} onHide={() => setShowImportModal(false)} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>Import Users</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <UserImport />
                        </Modal.Body>
                    </Modal> */}
                </Container>
            </main>
        </>
    );
};

export default UserList;
